// alertSlice.ts

import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { Alert, AlertExtend } from "src/types/store/storeTypes"
// ** Axios Imports
import axios from '../../../services/ApiService'

//interface Alert {
//    id: number;
//    type: 'success' | 'info' | 'warning' | 'error';
//    message: string;
//}

interface AlertState {
    tempAlerts: Alert[];
    alerts: AlertExtend[];
    incrementalAlerts: AlertExtend[];
    hasMore: boolean;
}

const initialState: AlertState = {
    tempAlerts: [],
    alerts: [],
    incrementalAlerts: [],
    hasMore : true
};

interface DataParams {
    alertId : string
}

// ** Fetch Lookups
export const fetchAlerts = createAsyncThunk('alert/fetchCurrentUserAlerts', async () => {
    const response = await axios.get('lookup/GetCurrentUserAlerts')
    return response;
})

export const fetchIncrementalAlerts = createAsyncThunk(
    'alerts/fetchIncrementalAlerts',
    async (_, { getState }) => {
        const { alert } = getState() as { alert: AlertState };
        const response = await axios.get<{ alerts: AlertExtend[], hasMore: boolean }>('lookup/GetIncrementalUserAlerts', {
            params: { start: alert.incrementalAlerts.length }
        });

        return response.data;
    }
);

// ** Mark alert as read
export const markAlertAsRead = createAsyncThunk(
    'alert/markAlertAsRead',
    async (data: DataParams) => {
        const response = await axios.post(`lookup/MarkAlertAsRead`, { alertGuid : data.alertId, read: true });
        return data.alertId;
    }
);


const alertSlice = createSlice({
    name: 'alert',
    initialState,
    reducers: {
        addTemporaryAlert: (state, action: PayloadAction<Alert>) => {
            state.tempAlerts.push(action.payload);
        },
        removeTemporaryAlert: (state, action: PayloadAction<number>) => {
            state.tempAlerts = state.tempAlerts.filter((alert) => alert.id !== action.payload);
        },
        addAlert: (state, action: PayloadAction<AlertExtend>) => {
            state.alerts.push(action.payload);
        },
        removeAlert: (state, action: PayloadAction<number>) => {
            state.alerts = state.alerts.filter((alert) => alert.id !== action.payload);
        },
    },
    extraReducers: builder => {
        builder.addCase(fetchAlerts.fulfilled, (state, action) => {
            state.alerts = action.payload.data
        }).addCase(markAlertAsRead.fulfilled, (state, action) => {
            const alertIndex = state.alerts.findIndex(alert => alert.alertGuid === action.payload);
            if (alertIndex >= 0) {
                state.alerts[alertIndex].isRead = true;
            }
        }).addCase(fetchIncrementalAlerts.fulfilled, (state, action) => {
            state.incrementalAlerts.push(...action.payload.alerts);
            state.hasMore = action.payload.hasMore;
        });
    }
});

export const { addTemporaryAlert, removeTemporaryAlert, addAlert, removeAlert } = alertSlice.actions;
export default alertSlice.reducer;
